import axios from 'axios'
import queryString from 'query-string'
import { decamelizeKeys, camelizeKeys } from 'humps'

import type { FetchArticlesParams, RawFetchArticlesResponse } from './types'
import { articleParser } from './parsers'

const CONTENT_URL = process.env.CONTENT_URL || 'localhost'

export async function fetch(params: FetchArticlesParams) {
  const response = await axios
    .get(`${CONTENT_URL}?${queryString.stringify(decamelizeKeys(params))}`)
    .then(
      (response) =>
        (camelizeKeys(response.data) as unknown) as RawFetchArticlesResponse,
    )

  return {
    articles: response.tiles.map(articleParser),
    lastEvaluatedKeyId: response.lastEvaluatedKeyId,
    lastSort: response.lastSort,
  }
}
